export var HelpdeskRoutes;
(function (HelpdeskRoutes) {
    HelpdeskRoutes["Main"] = "helpdesk";
    HelpdeskRoutes["Categories"] = ":helpdeskCategorySlug";
    HelpdeskRoutes["Article"] = ":helpdeskCategorySlug/:helpdeskArticleSlug";
})(HelpdeskRoutes || (HelpdeskRoutes = {}));
